import { BaseRouteService } from 'core/services';

class ReceivingProductRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'receiving-products/';
	}

	find = () => {
		return this.uriTemplateService.parse(`${this.base}search`).expand();
	};
}

export default ReceivingProductRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ReceivingProductRouteService.js